module.exports = __webpack_public_path__ + "img/Banner-Sijakon-BdanUsaha.f799577e.png";